import React, { PropsWithChildren, Suspense } from 'react';
import { InlineLoadingSpinner, InlineLoadingSpinnerProps } from '@/shared/components/InlineLoadingSpinner.tsx';

type Props = PropsWithChildren & InlineLoadingSpinnerProps;

export function InlineLoadingSuspenseBoundary({ children, ...loadingProps }: Props) {
    return <Suspense fallback={<InlineLoadingSpinner {...loadingProps} />}>{children}</Suspense>;
}
